"use strict";
/*
 * Created on 8. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = require("moment");

var moment = require("moment-timezone");
/**
 * Utility method for dates
 *
 * @author Stepan Mik
 */


var DateUtils =
/*#__PURE__*/
function () {
  function DateUtils() {
    _classCallCheck(this, DateUtils);
  }

  _createClass(DateUtils, null, [{
    key: "between",
    value: function between(rangeStart, rangeEnd, m) {
      return m.isSameOrAfter(rangeStart) && m.isSameOrBefore(rangeEnd);
    }
  }, {
    key: "overlaps",
    value: function overlaps(range1Start, range1End, range2Start, range2End) {
      return !(range1End.isBefore(range2Start) || range1Start.isAfter(range2End));
    }
  }, {
    key: "dayDiff",
    value: function dayDiff(date1, date2) {
      return moment_1.duration(date1.diff(date2)).asDays();
    }
  }, {
    key: "addDays",
    value: function addDays(date, days) {
      return date.clone().add(days, 'days');
    }
    /**
     * Get date difference as integer
     * @param date1
     * @param date2
     */

  }, {
    key: "dayDiffInteger",
    value: function dayDiffInteger(date1, date2) {
      return date1.diff(date2, 'days');
    }
    /**
     * Getter for week number based on provided date
     * It uses the isoWeek method, so it is ensured that the week number conforms to ISO (Czech) standard. If deployment
     * in other countries with different standards is expected and different result is desired, the week method should be
     * used, but than it has to be ensured a correct system locale is set.
     * @param date
     * @returns number
     */

  }, {
    key: "week",
    value: function week(date) {
      return date.isoWeek();
    }
    /**
     * Getter for week year based on provided date
     * The isoWeekYear method is used. For explanation see documentation to {@link DateUtils#week} method.
     * @param date
     * @returns number
     */

  }, {
    key: "weekYear",
    value: function weekYear(date) {
      return date.isoWeekYear();
    }
    /**
     * Getter for week year concatenated with week number based on provided date
     * @param date
     * @returns number
     */

  }, {
    key: "weekAndYear",
    value: function weekAndYear(date) {
      return this.weekYear(date) * 100 + this.week(date);
    }
    /**
     * Getter for year concatenated with a day number based on provided date
     * @param date
     * @returns number
     */

  }, {
    key: "dayAndYear",
    value: function dayAndYear(date) {
      return date.year() * 1000 + date.dayOfYear();
    }
    /**
     * Creates comparator function for date sorting. Default direction of sorting is asc.
     * @param asc
     */

  }, {
    key: "getDateComparator",
    value: function getDateComparator() {
      var asc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (asc) {
        return function (date1, date2) {
          return date1.valueOf() - date2.valueOf();
        };
      }

      return function (date1, date2) {
        return date2.valueOf() - date1.valueOf();
      };
    }
    /**
     * Creates an array of all days between given dates (inclusive).
     */

  }, {
    key: "getDayRange",
    value: function getDayRange(rangeStart, rangeEnd) {
      var dateArray = [];
      var currentDate = rangeStart.clone().startOf('day');

      while (currentDate.isSameOrBefore(rangeEnd)) {
        dateArray.push(currentDate);
        currentDate = currentDate.clone().add(1, 'day');
      }

      return dateArray;
    }
    /**
     * Getter for end week number based on provided date
     * @param startDate
     * @param endDate
     * @returns number
     */

  }, {
    key: "endWeek",
    value: function endWeek(startDate, endDate) {
      var weekDays = 7;
      var diff = DateUtils.dayDiff(endDate, startDate);

      if (diff > weekDays) {
        return DateUtils.week(endDate);
      } else {
        return DateUtils.week(startDate);
      }
    }
    /** Converts moment to week code ( Wxx/yy where xx is week number and yy is year ) */

  }, {
    key: "weekCode",
    value: function weekCode(date) {
      var d = date.clone();
      var week = this.week(d);
      var year = this.weekYear(d).toString().slice(-2);
      return "W".concat(week, "/").concat(year);
    }
    /**
     * Sets provided local time to clone of provided date.
     * @param date
     * @param time
     */

  }, {
    key: "setLocalTime",
    value: function setLocalTime(date, time) {
      return date.clone().hour(time.hour).minute(time.minute).second(time.second);
    }
    /**
     * Filter dates intersection.
     */

  }, {
    key: "getDatesIntersection",
    value: function getDatesIntersection(dates1, dates2) {
      return dates1.filter(function (dates1Value) {
        return dates2.find(function (dates2Value) {
          return dates2Value.isSame(dates1Value, 'date');
        });
      });
    }
  }, {
    key: "getTomorrowDate",
    value: function getTomorrowDate() {
      return moment().startOf('day').add(1, 'day');
    }
    /**
     * Returns true if the provided date is in the past. If the date is null, false is returned.
     *
     * @param date
     * @author Jan Prokop
     */

  }, {
    key: "isInThePast",
    value: function isInThePast(date) {
      return date !== null ? moment().isAfter(date) : false;
    }
  }]);

  return DateUtils;
}();

exports.DateUtils = DateUtils;
/**
 * Represents date to infinity (for IDB and the application itself).
 * Mentioned in https://docs.google.com/spreadsheets/d/1URTwN7vy0uUbNfUBdVVFiD2nSGlDyJOFWNtl9zYz2BA/edit#gid=1662328204
 */
// todo this could be configurable (and useful, it would unite some other definitions) and added to common part

DateUtils.DATE_TO_INFINITY = moment.utc('2049-12-31', 'YYYY-MM-DD').tz('Europe/Prague').endOf('day');